import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Flame } from "lucide-react";
import { SITE } from "@/data/site";

export const StickyBuy = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={SITE.links.pumpfun}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-buy-button"
          initial={{ opacity: 0, y: 30, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.9 }}
          className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 bg-gold hover:bg-gold-hover text-black font-body font-extrabold text-sm md:text-base px-6 py-3.5 rounded-full transition-colors duration-300 animate-pulse-glow uppercase tracking-wide"
        >
          <Flame className="w-5 h-5" /> Buy {SITE.ticker}
        </motion.a>
      )}
    </AnimatePresence>
  );
};
